import React, { useState } from 'react'
import Menu from 'redesign/components/atoms/menu'
import ActionMenuItem from './action-menu-item'
import { ANCHOR_ORIGIN, TRANSFORM_ORIGIN } from './constants'
import type { ActionButtonMenuProps } from './types'

const ActionButtonMenu: React.FC<ActionButtonMenuProps> = ({
  actions = [],
  open,
  onClose,
  anchorEl,
  anchorOrigin = ANCHOR_ORIGIN,
  transformOrigin = TRANSFORM_ORIGIN,
  topMenuMargin,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [itemAnchorEl, setItemAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setItemAnchorEl(event.currentTarget)
    setIsOpen(true)
  }

  return (
    <Menu
      data-testid="action-button-menu"
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      open={open}
      onClose={onClose}
      topMenuMargin={topMenuMargin}
    >
      {actions.map((action, index) => (
        <ActionMenuItem
          // Reason: we don't have a unique key for each action
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          {...action}
          anchorEl={itemAnchorEl}
          isMenuOpen={isOpen}
          setIsMenuOpen={setIsOpen}
          onClick={(event) => {
            handleButtonClick(event)
            action.onClick && action.onClick(event)
            onClose()
          }}
        />
      ))}
    </Menu>
  )
}

export default ActionButtonMenu
